
import { defineComponent } from 'vue';

import IconPlusCircle from '@white-label-icon/icon-plus-circle';
import IconArrowDown from '@white-label-icon/icon-arrow-down';
import IconCancel from '@white-label-icon/icon-cancel';
import IconClose from '@white-label-icon/icon-close';
import IconEnvelope from '@white-label-icon/icon-envelope';
import IconLoungeBooking from '@white-label-icon/icon-lounge-booking';
import IconPlus from '@white-label-icon/icon-plus';
import IconPrinter from '@white-label-icon/icon-printer';
import IconSettings from '@white-label-icon/icon-settings';
import IconShare from '@white-label-icon/icon-share';
import IconUser from '@white-label-icon/icon-user';
import IconParking from '@white-label-icon/icon-parking';
import IconBookmark from '@white-label-icon/icon-bookmark';
import IconCalendar from '@white-label-icon/icon-calendar';
import IconPencil from '@white-label-icon/icon-pencil';
import IconAskMark from '@white-label-icon/icon-ask-mark';
import IconLink from '@white-label-icon/icon-link';

export default defineComponent({
  name: 'IconButton',

  components: {
    IconPlusCircle,
    IconArrowDown,
    IconCancel,
    IconClose,
    IconEnvelope,
    IconLoungeBooking,
    IconPlus,
    IconPrinter,
    IconSettings,
    IconShare,
    IconUser,
    IconParking,
    IconBookmark,
    IconCalendar,
    IconPencil,
    IconAskMark,
    IconLink,
  },

  props: {
    iconName: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
